var counters = [];

$(window).on("load", function(){
	$("body").trigger("initializeCounters");
});

$("body").on("initializeCounters", function (e) {
	var counterEl = $(this).find(".js-counter").not(".initialized");
	if(counterEl.length > 0){
		counterEl.each(function (obj, index) {
			$(this).addClass("initialized");
			counters.push(new counterObj($(this)));
		});
	}
});


function counterObj(counterEl) {

	this.day = counterEl.data("endday");
	this.startDay = counterEl.data("startday");
	this.size = counterEl.data("size") || 100;
	this.lineWidth = counterEl.data("linewidth") || 2;
	this.counterFont = counterEl.data("font") || 'bold 17pt Open Sans';
	this.counterSubFont = counterEl.data("subfont") || '300 9pt Open Sans';
	this.simple = parseInt(counterEl.data("simple"));

	if(this.simple === 1){
		this.simple = true;
	}else{
		this.simple = false;
	}

	this.counterEl = counterEl;

	this.rgb = '#013473';
	this.rgba = 'rgba(158,158,158,0)';
	this.fill = '#f17825';
	this.textColor = 'white';
	this.fontFamily = "Open Sans";

	this.$countdown = $(this).find('.js-countdown');
	this.$days = $('<canvas id="s-days" height="' + this.size + '" width="' + this.size + '" />');
	this.$hours = $('<canvas id="s-hours" height="' + this.size + '" width="' + this.size + '" />');
	this.$minutes = $('<canvas id="s-minutes" height="' + this.size + '" width="' + this.size + '" />');
	this.$seconds = $('<canvas id="s-seconds" height="' + this.size + '" width="' + this.size + '" />');

	this.secondsLeft = -1;
	this.hoursLeft = -1;
	this.minutesLeft = -1;
	this.daysLeft = -1;

	this.maxes = {
		"seconds" : 60,
		"minutes" : 60,
		"hours" : 24,
		"days" : 50
	}

	if(!this.simple){
		this.$days.appendTo(counterEl);
		this.$hours.appendTo(counterEl);
		this.$minutes.appendTo(counterEl);
		this.$seconds.appendTo(counterEl);
	}

	var _this = this;
	this.dateInterval = setInterval(function(){
		_this.tick();
	}, 1000);

}


counterObj.prototype.clearCircle = function (ctx) {
	ctx.clearRect(0, 0, this.size, this.size);
}

counterObj.prototype.drawText = function(canvas, ctx, txt) {
	var x = canvas.width / 2;
	var y = canvas.height / 2 - 8;

	ctx.font = this.counterFont;
	ctx.textAlign = 'center';
	ctx.textBaseline = 'middle';
	ctx.fillStyle = this.textColor;
	ctx.fillText(txt, x, y);

}

counterObj.prototype.drawSubtitle = function(canvas, ctx, txt){
	var x = canvas.width / 2;
	var y = canvas.height / 2 + 11;
	ctx.font = this.counterSubFont;
	ctx.textAlign = 'center';
	ctx.textBaseline = 'middle';
	ctx.fillStyle = this.textColor;
	ctx.fillText(txt, x, y);
}

counterObj.prototype.setTrack = function(ctx) {
	ctx.strokeStyle = this.rgba;
	ctx.lineWidth = this.lineWidth/2;
	ctx.beginPath();
	ctx.arc(this.size/2, this.size/2, this.size/2-11, 0, Math.PI*2);
	ctx.fillStyle = this.fill;
	ctx.fill();
	ctx.stroke();
}

counterObj.prototype.createCircle = function(ctx, now, total) {
	ctx.strokeStyle = this.rgb;
	ctx.lineWidth = this.lineWidth;
	ctx.beginPath();
	ctx.arc(
		this.size/2,
		this.size/2,
		this.size/2-8,
		Math.PI/-2,
		( Math.PI * 2 ) * ( now / total ) + ( Math.PI / -2 ),
		false
	);
	ctx.stroke();
}

counterObj.prototype.tick = function() {
	this.seconds = moment(this.day).diff(moment(), 'seconds');

	var secondsLeft = this.seconds %60;
	var minutes = Math.floor(this.seconds / 60);
	var minutesLeft = minutes % 60;
	var hours = Math.floor(minutes /60);
	var hoursLeft = hours % 24;
	var daysLeft = Math.floor(hours / 24);


	var flashSalesContainer = document.getElementsByClassName("fshr-flashSalesContainer");
	if(flashSalesContainer.length == 1){
		if(this.seconds < 0){
			flashSalesContainer[0].style.display = "none";
		}else{
			flashSalesContainer[0].style.display = "block";
		}
	}

	var hoursObj = {
		'seconds' : secondsLeft,
		'minutes' : minutesLeft,
		'hours' : hoursLeft,
		'days' : daysLeft
	};

	if(!this.simple){
		for(var i in hoursObj){
			if(hoursObj[i] != this[i +"Left"]){
				this[i+"Left"] = hoursObj[i];
				this.updateValue(i, hoursObj[i]);
			}
		}
	}else{
		this.renderSimple(hoursObj);
	}

};

counterObj.prototype.renderSimple = function(hoursObj) {
	var days = hoursObj.days;
	var hours = ("0" + hoursObj.hours).slice(-2);
	var minutes = ("0" + hoursObj.minutes).slice(-2);
	var seconds = ("0" + hoursObj.seconds).slice(-2);
	this.counterEl.html('<div class="fshr-simpleCountdown"><span class="days">' + days + '</span> : <span class="hours">' + hours + '</span> : <span class="minutes">' + minutes + '</span> : <span class="seconds">' + seconds + '</span></div>');
};

counterObj.prototype.updateValue = function(name, newValue){
	var elementName = '$' + name;
	var element = this[elementName][0];

	if(element){
		var ctx = element.getContext("2d");
	}

	var subtitle = getUnit(newValue, name);

	this.clearCircle(ctx);
	this.setTrack(ctx);
	this.drawSubtitle(element, ctx, subtitle);
	this.drawText(element, ctx, newValue);
	this.createCircle(ctx, newValue, this.maxes[name]);
};


function getUnit(count, unit){
    var index = -1;
    count = Math.abs(count);
    if(count == 0){
    	index = 2;
    }
    if (count == 1){
        index = 0;
    }
    if (count > 1 && count < 5 ){
        index = 1;
    }
    if (count > 4){
        index = 2;
    }
    var dictionary = window.fshr.localization.counter;

    if(unit == "seconds") unit = 's';
	if(unit == "minutes") unit = 'm';
	if(unit == "hours") unit = 'h';
	if(unit == "days") unit = 'd';

    var finalVerb = dictionary[unit][index];
    return finalVerb;
}